import React, { useState } from 'react'
import { FeedbackInitial } from './FeedbackInitial'
import { FeedbackInternal } from './FeedbackInternal'
import { FeedbackCompleted } from './FeedbackCompleted'
import '../../styles/ExpandedFeedbackModule/ExpandedFeedbackModule.scss'

type FeedbackView = 'initial' | 'internal' | 'completed'

export const ExpandedFeedbackModule = () => {
  const [view, setView] = useState<FeedbackView>('initial')
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) {
    return <section className="expanded-feedback-module expanded-feedback-module--dismissed" aria-hidden="true" />
  }

  return (
    <section className="expanded-feedback-module" aria-labelledby="expanded-feedback-heading">
      <div className="expanded-feedback-module__content">
        {view === 'initial' && (
          <FeedbackInitial
            onContact={() => setView('internal')}
            onDismiss={() => setDismissed(true)}
          />
        )}

        {view === 'internal' && (
          <FeedbackInternal onSubmitted={() => setView('completed')} />
        )}

        {view === 'completed' && <FeedbackCompleted />}
      </div>
    </section>
  )
}
